export default "__VITE_ASSET__CIF3$JXu__"